<template>
  <img src="@/assets/images/logos/test_center_kz%201.png"/>
</template>
<script setup>
</script>